import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/faq';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-ivory py-10 sm:py-12" aria-labelledby="faq-heading" data-id="element-72" data-mp="1bl23p9e8x8f0">
      <div className="mx-auto max-w-3xl px-6" data-id="element-73" data-mp="1gjc0tpjj6j39">
        <div className="text-center" data-id="element-74" data-mp="1gk5b30hp7qq5">
          <p className="eyebrow text-terracotta-deep" data-id="element-75" data-mp="2496c42o7bzle">Before you decide</p>
          <h2 id="faq-heading" className="mt-5 font-display text-[2rem] leading-[1.12] text-ink sm:text-4xl" data-id="element-76" data-mp="249zkf82t6x5n">
            Frequently asked questions
          </h2>
        </div>

        <ul className="mt-12 space-y-2.5" data-id="element-77" data-mp="1uilhsrfk9h8a">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} className={`rounded-3xl border bg-shell transition-colors duration-150 ease-out ${isOpen ? 'border-terracotta/45' : 'border-line'}`} data-id="element-78" data-mp="1zg4u3lsp7jxl" data-mpi={index}>
                <h3 data-id="element-79" data-mp="2s0bpmb6o6fsj">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-6 rounded-3xl px-6 py-5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-terracotta" data-id="element-80" data-mp="2s0vao0rm9kas">
                    <span className="font-display text-lg leading-snug text-ink sm:text-xl" data-id="element-81" data-mp="19tc3h744y4pg">
                      {faq.question}
                    </span>
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors duration-150 ease-out ${isOpen ? 'bg-terracotta text-ivory' : 'bg-terracotta-light text-terracotta-deep'}`} aria-hidden="true" data-id="element-82" data-mp="1jk6rafx15cd0">
                      <PlusIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-83" data-mp="1slxt39og8z1l" />
                    </span>
                  </button>
                </h3>

                <div id={`faq-panel-${index}`} className={`grid transition-[grid-template-rows,opacity] duration-200 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-84" data-mp="3udjcfv26ukay">
                  <div className="overflow-hidden" data-id="element-85" data-mp="238zd1rk6fhea">
                    <p className="px-6 pb-6 font-sans text-[0.93rem] leading-relaxed text-stone" data-id="element-86" data-mp="287aog6q4dzym">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}